import React from 'react';
import { ReactComponent as SubstitutionIcon } from 'components/icons/substitution.svg';
import { observer } from 'mobx-react-lite';
import { IApiLineupPlayer } from '@trackman/baseball-shared-components';
import classNames from 'classnames';
import { Controls, Name, TaggingLineupPlayerWrapper } from '../TaggingLineupPlayerStyles';

export interface IProps {
  player: IApiLineupPlayer;
  onClickSubstitutionCallback?: (player: IApiLineupPlayer) => void;
  disabled?: boolean;
}
export const LineupPitcher: React.FC<IProps> = observer((props: IProps) => {
  const { onClickSubstitutionCallback, player, disabled } = props;

  const lineupPitcherClasses = classNames({
    disabled,
  });

  return (
    <TaggingLineupPlayerWrapper current className={`pitcher ${lineupPitcherClasses}`}>
      <Name>
        {player.nameRef} {player.jerseyNumber ? `#${player.jerseyNumber}` : ''}
      </Name>
      <Controls>
        <span>
          <SubstitutionIcon onClick={() => onClickSubstitutionCallback && onClickSubstitutionCallback(player)} />
        </span>
      </Controls>
    </TaggingLineupPlayerWrapper>
  );
});
